export default {"src":"/_next/static/media/quality_second_image_right.2e2d2953.svg","height":197,"width":524,"blurWidth":0,"blurHeight":0};